import { render, staticRenderFns } from "./designationArchive.vue?vue&type=template&id=5cc29988&"
import script from "./designationArchive.vue?vue&type=script&lang=js&"
export * from "./designationArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports